import { Compass, DollarSign, AlertCircle, FileText, Clock, Headphones } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function UscisForms() {
    const features = [
        {
            icon: Compass,
            title: "Simple Directions",
            description: (
                <>
                    USCIS guidance uses legal language and can be very confusing. If you get stuck, there is no phone or email support. citizenhup provides simple, step-by-step directions. We also have{' '}
                    <Link to="#" className="text-blue-600 hover:underline">highly-rated customer support</Link> to help you.
                </>
            )
        },
        {
            icon: DollarSign,
            title: "Affordable to All",
            description: "citizenhup's online immigration services can save you thousands of dollars compared to an attorney. Even if you can prepare the forms, it's low-cost reassurance that you're doing everything correctly."
        },
        {
            icon: AlertCircle,
            title: "Instant Alerts to Avoid Mistakes",
            description: "Get instant alerts if there's a problem. If citizenhup detects that your answer to a question creates a problem, you get immediate feedback. USCIS has no vested interest to see your application approved. Their online system is to make intake easier for the government. It's not designed to protect you."
        },
        {
            icon: FileText,
            title: "Personalized Filing Instructions",
            description: "We provide customized filing instructions so that you know exactly which supporting documents to submit for your specific situation. We'll also explain how to organize your application and where to file it. USCIS filing instructions are long, generic, and hard to decipher."
        },
        {
            icon: Clock,
            title: "Quick Processing Times",
            description: "Mistakes and omissions are what cause major delays, rejections and denials. Filing via USCIS e-file can save you a few days in the beginning, but submitting a well-prepared form is what helps ensure a quick processing time. Even if you have to mail that form."
        },
        {
            icon: Headphones,
            title: "Friendly, Live Customer Service",
            description: (
                <>
                    citizenhup's{' '}
                    <Link to="#" className="text-blue-600 hover:underline">highly-rated customer support</Link> is ready to assist. We can't wait to help you.
                </>
            )
        }
    ];

    return (
        <section className="py-16 px-4 bg-white">
            <div className="max-w-[80rem] mx-auto">
                <h2 className="text-3xl md:text-4xl font-bold text-center text-blue-600 mb-16">
                    Why People Are Using citizenhup to Prepare USCIS Forms
                </h2>

                <div className="relative">
                    {/* Vertical timeline line */}
                    <div className="absolute left-[31px] top-0 bottom-0 w-0.5 bg-gray-300 hidden md:block" />

                    <div className="space-y-12">
                        {features.map((feature, index) => {
                            const Icon = feature.icon;
                            return (
                                <div key={index} className="relative flex gap-6 items-start">
                                    {/* Icon circle */}
                                    <div className="flex-shrink-0 w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center relative z-10">
                                        <Icon className="w-8 h-8 text-white" strokeWidth={2} />
                                    </div>

                                    {/* Content */}
                                    <div className="flex-1 pt-2">
                                        <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                                            {feature.title}
                                        </h3>
                                        <p className="text-gray-700 leading-relaxed">
                                            {feature.description}
                                        </p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
}